import type { EquityRange } from '../types'

/**
 * Global measurement window (spec §4). DAY is the default: every
 * performance number re-aggregates to "today"; equity charts render
 * max(window, 1W) because history is daily-resolution.
 */
export type Timeframe = 'DAY' | '1W' | '1M' | '3M' | 'ALL'

export const TIMEFRAMES: Timeframe[] = ['DAY', '1W', '1M', '3M', 'ALL']

export function toEquityRange(tf: Timeframe): EquityRange {
  return tf === 'DAY' ? '1W' : tf
}

export function timeframeLabel(tf: Timeframe): string {
  if (tf === 'DAY') return 'Day'
  if (tf === 'ALL') return 'All'
  return tf
}
